import React from 'react';

import classNames from 'classnames';
import styles from '../assets/css/offers.module.css';
import { formatFullDate, getHumanDuration } from '../lib/timeFormat';
import Segments from './Segments';

const Slices = ({
  baggages,
  tripType,
  slices = [],
  mode = 'compact',
  onClick,
}) => {
  const lastSliceIndex = slices.length - 1;
  
  return (
    <div className={ mode === 'detailed' ? styles.slice_outer_container : classNames(styles.slice_outer_container, styles.slice_simple_conainer)} onClick={onClick}>
      <div
        className={
            mode === 'detailed'
              ? styles.offer_card_details_container
              : classNames(
                styles.offer_card_details_container,
                styles.slice_container
              )
        }
      >
        {slices.map((slice, index) => {
          const cabinClass = Array.from(
            new Set(slice.cabinClasses.map(({ labelAr }) => labelAr))
          ).join(' ');

          return (
            <div className={styles.offer_card}>
              <div
                className={styles.offer_card_details}
                key={index}
                style={index > 0 ? { borderRadius: '0' } : {}}
              >
                <Segments slice={slice} mode={mode} />
                
                <div
                  className={classNames(
                    styles.offer_card_row,
                    styles.offer_card_header
                  )}
                  style={mode === 'detailed' ? {background:'rgba(0, 0, 0, 0.03)'} : {}}
                >
                  <div className={styles.offer_card_row}>
                    <div className={styles.pill}>
                      <span className="iconify" data-icon="material-symbols:calendar-today-sharp"></span>
                      {formatFullDate(slice.departureDate)}
                    </div>
                    
                    <div className={styles.pill} style={{paddingRight:3}}>
                      <span className="iconify" data-icon="material-symbols:airline-seat-recline-normal-rounded"></span>
                      {cabinClass}
                    </div>

                    {baggages && <div className={styles.pill} style={{paddingRight:4}}>
                      <span className="iconify" data-icon={baggages.hold.quantity > 0 ? 'material-symbols:luggage' : 'material-symbols:no-luggage'}></span>
                      {baggages.hold.quantity > 0 ? `${baggages.hold.weight}kg x ${baggages.hold.quantity}` : 'بدون أمتعة'}
                    </div>}
                  </div>
                    
                  <div className="avatars-container">
                    {slice.airlines.map((airline) => {
                      return (
                        <div className="avatar tooltip">
                          {airline.logo !== null && <img alt={airline.nameEn} src={airline.logo} />}
                          {airline.logo == null && <div>{airline.iataCode}</div>}
                          <span className="left-tooltip-text">
                            {airline.nameEn}
                          </span>
                        </div>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default Slices;
